/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { SupplyToken, SupplyTokenInterface } from '../SupplyToken'

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_controller',
        type: 'address'
      },
      {
        internalType: 'string',
        name: '_name',
        type: 'string'
      },
      {
        internalType: 'string',
        name: '_symbol',
        type: 'string'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Approval',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Transfer',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      }
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'subtractedValue',
        type: 'uint256'
      }
    ],
    name: 'decreaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'addedValue',
        type: 'uint256'
      }
    ],
    name: 'increaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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'

export class SupplyToken__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    _controller: string,
    _name: string,
    _symbol: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SupplyToken> {
    return super.deploy(
      _controller,
      _name,
      _symbol,
      overrides || {}
    ) as Promise<SupplyToken>
  }
  getDeployTransaction(
    _controller: string,
    _name: string,
    _symbol: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _controller,
      _name,
      _symbol,
      overrides || {}
    )
  }
  attach(address: string): SupplyToken {
    return super.attach(address) as SupplyToken
  }
  connect(signer: Signer): SupplyToken__factory {
    return super.connect(signer) as SupplyToken__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): SupplyTokenInterface {
    return new utils.Interface(_abi) as SupplyTokenInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SupplyToken {
    return new Contract(address, _abi, signerOrProvider) as SupplyToken
  }
}
